import { useCallback, useEffect, useState } from 'react';
import { GetAdminChangelogMediaAPI, UploadAdminChangelogMediaAPI } from '../../../../api/AdminAPI';

/**
 * useChangelogMedia
 *
 * Mídias já enviadas de um tipo (media.php) e o envio de uma nova (media_upload.php).
 *
 * @param {'image'|'video'|'poster'|'captions'} kind
 */
function useChangelogMedia(kind) {
  const [media, setMedia] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    GetAdminChangelogMediaAPI(kind, (response) => {
      if (!active) return;
      setIsLoading(false);
      if (!response || response.success === false) {
        setError(response?.error || 'Não foi possível carregar os arquivos.');
        return;
      }
      setMedia(Array.isArray(response.media) ? response.media : []);
    });
    return () => { active = false; };
  }, [kind]);

  /** onUploaded(media) recebe a mídia nova, já incluída na lista. */
  const upload = useCallback((file, label, onUploaded) => {
    setIsUploading(true);
    setError(null);
    UploadAdminChangelogMediaAPI(file, kind, label, (response) => {
      setIsUploading(false);
      if (!response || response.success === false || !response.media) {
        setError(response?.error || 'Não foi possível enviar o arquivo.');
        return;
      }
      setMedia((prev) => [response.media, ...prev.filter((m) => m.id !== response.media.id)]);
      if (onUploaded) onUploaded(response.media);
    });
  }, [kind]);

  return { media, isLoading, isUploading, error, upload };
}

export default useChangelogMedia;
